import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useDeleteClaimMarker() {
  return useMutation(trpcOptions.app.deleteClaimMarker.mutationOptions())
}
